import lockr from 'lockr';

const siteName = process.env.VUE_APP_SITE_NAME;
/* eslint-disable no-irregular-whitespace */
export const messageTip = {
  time: 0,
  title: document.title,
  timer: null,
  show() {
    document.title = `【新消息】${this.title}`;
    // const title = this.title.replace('【　　　】', '').replace('【新消息】', '');
    // window.clearTimeout(this.timer);
    // this.timer = window.setTimeout(() => {
    //   this.time++;
    //   this.show();
    //   if (this.time % 2 === 0) {
    //     document.title = `【新消息】${title}`;
    //   } else {
    //     document.title = `【　　　】${title}`;
    //   }
    // }, 600);
    return [this.timer, this.title];
  },
  clear() {
    window.clearTimeout(this.timer);
    document.title = this.title;
  }
};

class Message {
  constructor(store, notification) {
    this.store = store;
    this.notification = notification;
  }

  parse(message) {
    this.store.commit('updateSocketMessage', message);
    if (message.indexOf('num,') > -1) {
      return this.showNoticeAmount(message);
    }

    try {
      let msgData = JSON.parse(message);
      if (msgData.name && this[msgData.name]) {
        return this[msgData.name](msgData);
      }
      // eslint-disable-next-line
    } catch (e) {
      // console.log(e);
    }

    // 清除 localStorage 缓存
    if (message === 'clearcache') {
      lockr.flush();
      return true;
    }

    if (message.indexOf('IM_NOTICE') > -1) {
      let imNoticeMsg = JSON.parse(message);
      if (imNoticeMsg) {
        imNoticeMsg = imNoticeMsg.IM_NOTICE;
        if (this.store.state.userinfo.userid === +imNoticeMsg.userid) {
          this.store.commit('updateImNotifyMessage', imNoticeMsg);
        }
      }
      return true;
    }
    if (message.indexOf('sendBubbleNotice') > -1) {
      let BubbleNoticeMsg = JSON.parse(message);
      if (BubbleNoticeMsg.bubbleCount !== 0 && (siteName === 'training' || siteName === 'fib')) {
        this.store.commit('setBubbleCount', BubbleNoticeMsg.bubbleCount);
      }
    }
    console.log(message);
  }

  /**
   * 消息总算通知
   * @param {String} message
   */
  showNoticeAmount(message) {
    const num = message.replace('num,', '') - 0;
    this.store.commit('updateMessageAmount', num);
    if (num > 0) {
      messageTip.show();
    } else {
      messageTip.clear();
    }
    return true;
  }

  /**
   * 浏览器通知，发送通知直接直接转发到老师浏览器
   */
  sendNotice(msg) {
    let icon = '';
    let remindPage = '';
    switch (process.env.VUE_APP_SITE_NAME) {
      case 'fib':
        // eslint-disable-next-line
        icon = require('@/assets/logo/fib.png');
        remindPage = '/frontend/system/remind';
        break;
      case 'training':
        // eslint-disable-next-line
        icon = require('@/assets/logo/starmap.png');
        remindPage = '/system/remind';
        break;
      default:
        icon = '';
    }
    this.notification.show(msg.title, {
      body: msg.body,
      icon,
    }, {
      onclick() {
        window.open(remindPage, 'notify_page');
      }
    });
  }
}
export default Message;
